/**
 * Dev-only logging helpers.
 * In production, these no-op — so we don't ship debug info or waste cycles.
 * In development, they behave like console.warn / console.error.
 */
const isDev = process.env.NODE_ENV !== "production";

export const devWarn = isDev
  ? (...args) => console.warn(...args)
  : () => {};

export const devError = isDev
  ? (...args) => console.error(...args)
  : () => {};

export const devInfo = isDev
  ? (...args) => console.info(...args)
  : () => {};
